<template>
	<div>
		<div class="row"
		     style="margin-bottom: 0;">
			<div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
				<h5 class="center-align white-text">
					Администраторы сервиса
				</h5>
				<div class="row"
				     style="margin-bottom: 0;">
					<div class="input-field col s12 m8 l8 xl8">
						<input id="first_name2"
						       type="text"
						       @keyup="search($event)"
						       class="white-text">
						<label class="white-text"
						       for="first_name2">Search login</label>
					</div>
					<div class="col s12 m4 l4 xl4 main">
						<router-link :to="'admins/add'"
						             class="waves-effect waves-light btn indigo darken-3 btn-small"
						             style="width: 100%;">
							<i class="material-icons left">add</i>
							новый администратор
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
				<div v-for="admin in adminsList"
				     data-id="card"
				     :data-login="admin.login">
					<table class="highlight card bg"
					       :data-id="admin.id">
						<tbody>
						<tr :key="admin.id">
							<td>логин</td>
							<td>{{admin.login}}
								<a @click="deleteAdmin(admin.login)"
								   style="margin: 5px 0; position:absolute; right: 0; width: 50px; top: -3px;"
								   :data-login="admin.login"
								   data-tooltip="удалить навсегда"
								   id="test"
								   class="btn red lighten-2 waves-effect tooltips
								waves-light btn-small width-btn col s12 m5 l5 xl5">
									<i class="material-icons">delete_forever</i>
								</a>
							</td>
						</tr>
						<tr>
							<td>заметка</td>
							<td>{{admin.note}}</td>
						</tr>
						<tr>
							<td>включен</td>
							<td><i class="material-icons  darken-3"
							       :class="admin.enabled ?  'green-text' : 'red-text'">
								{{admin.enabled ? "check_circle_outline" : "highlight_off"}}
							</i></td>
						</tr>
						<tr>
							<td>права на запись</td>
							<td><i class="material-icons  darken-3"
							       :class="!admin.read_only ?  'green-text' : 'red-text'">
								{{admin.enabled ? "check_circle_outline" : "highlight_off"}}
							</i></td>
						</tr>
						<tr>
							<td>Root</td>
							<td><i class="material-icons  darken-3"
							       :class="admin.is_root ?  'green-text' : 'red-text'">
								{{admin.enabled ? "check_circle_outline" : "highlight_off"}}
							</i></td>
						</tr>
						<tr>
							<td>Валидация</td>
							<td><i class="material-icons  darken-3"
							       :class="admin.validated ?  'green-text' : 'red-text'">
								{{admin.enabled ? "check_circle_outline" : "highlight_off"}}
							</i></td>
						</tr>
						<tr>
							<td>телефон</td>
							<td class="tooltipped darken-3 bold"
							    :class="admin.validated ? 'green-text' : 'red-text'"
							>{{admin.phone || "телефон не привязан"}}
							</td>
						</tr>
						<tr>
							<td colspan="2"
							    class="row">
								<a class="btn indigo lighten-1 waves-effect waves-light btn-small col s12 m5 l5 xl5"
								   style="margin: 5px 0;"
								   @click="$router.push(path(admin))">
									<i class="material-icons left">domain</i>
									список домов - {{admin.buildings ? admin.buildings.length : "нет"}}
								</a>
								<div class="col hide-on-small-only m2 l2 xl2"></div>
								<a @click="edit($event)"
								   style="margin: 5px 0;"
								   :data-login="admin.login"
								   class="btn teal lighten-1 waves-effect
									    waves-light btn-small width-btn col s12 m5 l5 xl5">
									<i class="material-icons left">border_color</i>
									Изменить</a>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import admins                     from "../../plugins/controllers/admins";
	import setRules                   from "../../assets/setRules";
	import { eventEmitter }           from "../../main";
	import { mapState, mapMutations } from "vuex";
	//import swal                       from "sweetalert";
    import Swal from 'sweetalert2'
	import preload                    from "../../assets/preload";
	// import TableBuildings             from "../../components/buildings/TableBuildings";
	// import BuildingsFromAdmin         from "../../components/buildings/BuildingsFromAdmin";

	export default {
		name:     "Admins",
		// components: { BuildingsFromAdmin, TableBuildings },
		data() {
			return {
				adminsList: [],
				buildings:  [],
				e:          null
			};
		},
		beforeMount() {
			eventEmitter.$once("tokenSuccess", this.getAllAdmins);
		},
		beforeDestroy() {
			if (this.e) {
				this.e.forEach(el => {
					el.destroy();
				});
			}
			eventEmitter.$off("tokenSuccess", this.getAllAdmins);
		},
		mounted() {
			if (this.tokenSuccess) {
				this.getAllAdmins();
			} else {
				console.log("token is not success");
			}
			// preload.show();
		},
		computed: {
			...mapState(["tokenSuccess"]),

		},
		methods:  {
			...mapMutations([
				"setAuth",
				"setShowMenu"
			]),
			path(admin) {
				return `users/adminsBuildings?user=${admin.login}&buildings=${JSON.stringify(admin.buildings)}`;
			},
			search(e) {
				let elements = document.querySelectorAll("[data-id=\"card\"]");
				Array.from(elements).forEach(elem => {
					if (elem.getAttribute("data-login").toUpperCase()
						.indexOf(e.target.value.toUpperCase()) !== -1) {
						if (elem.classList.contains("hidden")) {
							elem.classList.remove("hidden");
						}
					} else {
						elem.classList.add("hidden");
					}
				});
			},
			edit(event) {
				this
					.$router
					.push(`admins/get/${event
						.currentTarget
						.getAttribute("data-login")}`);
			},
			deleteAdmin(login) {
                Swal.fire({
                    title:   `Вы уверены?`,
                    text:    `Удаление администаратора ${login}?`,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отмена',
                    confirmButtonText: 'Удалить!'
                }).then(res => {
					if (res) {
						admins.deleteAdmin(login)
							.then(res => {
								setRules(res);
								this.getAllAdmins();
								this.$toast.success({
									title:   "Пользователь был успешно удален",
									message: "Можете продолжить использование сервиса"
								});
							})
							.catch(e => {
								console.log(e);
								this.$toast.error({
									title:   "При удалении произошла ошибка",
									message: "Свяжитесь с администратором сервиса"
								});
							})
							.then(() => {
							});
					}
				}).catch(e => {
					console.log("error", e);
				});

			},
			getAllAdmins() {
				console.log("admins");
				// this.setPreload(true);
				// preload.show();
				admins.getAdmins()
					.then(res => {
						console.log("getAllAdm", res);
						setRules(res);

						if (res.data && res.data.admins) {
							this.adminsList = res.data.admins;

						} else {
							this.$toast.warn({
								title:   "Сервер присал не корректные данные",
								message: "Свяжитесь с администратором сервиса"
							});
						}
					})
					.catch(e => {
						this.setAuth(true);
						this.setShowMenu(false);
						console.log("Admins", e);
						if (e.message.toLowerCase() === "network error") {
							this.$toast.error({
								title:   "Ошибка с соединением",
								message: "Проблемы с интернет-подключением или с доступом к серверу"
							});
						} else {
							this.$toast.error({
								title:   "Произошла ошибка",
								message: "Авторизуйтесь с вашей учетной записи"
							});
						}
					})
					.then(() => {
						// preload.hidden();
						if (!this.e) {
							let elements = document.querySelectorAll(".tooltips");
							this.e       = M.Tooltip.init(elements, {
								position: "left"
							});
						}
					});
			},
		}
	};
</script>
<style scoped lang="scss">
	.bold {
		font-weight: 500;
	}
	
	.main {
		margin-top: 15px;
	}
	
	@media screen and (max-width: 600px) {
		.main {
			margin: 0;
		}
		h5 {
			font-size: 16px;
			margin-bottom: 0;
		}
	}
	
	input[type=text]:not(.browser-default) {
		border-bottom: 1px solid #d0d0d0;
		box-shadow: 0 1px 0 #d0d0d0;
	}
	
	input[type="text"]:not(.browser-default):focus:not([readonly]) {
		border-bottom: 1px solid #f0e8f1;
		box-shadow: 0 1px 0 #dfd8df;
	}
	
	label.white-text {
		color: #d0d0d0 !important;
		
		&.active {
			color: #fff !important;
		}
	}
	
	.hidden {
		display: none;
	}
	
	input[type="text"] {
		&:not(.browser-default):focus:not([readonly]) + label {
			color: #fff;
		}
	}
	
	.bg {
		background-color: rgba(56, 56, 56, 0.8);
	}
	
	[type="checkbox"]:checked + span:not(.lever):before {
		border: 2px solid transparent;
		border-right-color: white;
		border-bottom-color: white;
	}
	
	[type="checkbox"] + span:not(.lever):before {
		border: 2px solid white;
	}
	
	table.highlight > tbody > tr > td {
		padding: 7px 10px;
		font-size: 14px;
	}
	
	table.highlight > tbody > tr:hover {
		background-color: rgba(36, 37, 40, 0.51);
	}
	
	tr {
		cursor: pointer;
	}
	
	tr th {
		cursor: default;
	}
	
	tr td:first-child {
		width: 20%;
		font-weight: 600;
		text-transform: uppercase;
	}
	
	tr td:last-child {
		text-align: center;
	}
</style>
